import { useEffect } from 'react';
import { ButtonGradient } from '@g17eco/atoms/button';
import { AssistantOffcanvas } from './AssistantOffcanvas';
import { AssistantTabs } from './assistantTypes';
import { FeatureStability } from '@g17eco/molecules/feature-stability';
import { AnswerProps } from './ai-assistant/types';
import { Button } from 'reactstrap';
import { useAssistantPanelContext } from './AssistantPanelContext';
import { SMART_MATCH } from '@constants/terminology';

interface Props extends AnswerProps {
  canAccessAITools: boolean;
}

export const AssistantBtn = ({ utr, utrv, initiativeUtr, canAccessAITools }: Props) => {
  const { isOpen, openToTab, close } = useAssistantPanelContext();

  useEffect(() => {
    const questionContainerElement = document.getElementById('question-container');
    if (isOpen) {
      questionContainerElement?.classList.add('has-sidebar-left');
    } else {
      questionContainerElement?.classList.remove('has-sidebar-left');
    }
  }, [isOpen]);

  const handleToggle = () => {
    if (isOpen) {
      close();
    } else {
      openToTab(canAccessAITools ? AssistantTabs.Assistant : AssistantTabs.SmartMatches);
    }
  };

  return (
    <>
      {canAccessAITools ? (
        <ButtonGradient onClick={handleToggle} key={`assistant-btn-${isOpen ? 'open' : 'close'}`}>
          <i className='fal fa-sparkles mr-2' />
          Assistant
          <FeatureStability stability={'beta'} />
        </ButtonGradient>
      ) : (
        <Button outline color='secondary' onClick={handleToggle} key={`assistant-btn-${isOpen ? 'open' : 'close'}`}>
          <i className='fal fa-diagram-nested mr-2' />
          {SMART_MATCH.CAPITALIZED_PLURAL}
        </Button>
      )}
      <AssistantOffcanvas
        utrv={utrv}
        utr={utr}
        initiativeUtr={initiativeUtr}
        open={isOpen}
        toggle={handleToggle}
        canAccessAITools={canAccessAITools}
      />
    </>
  );
};
